import { render, staticRenderFns } from "./ThumbsUpIcon.vue?vue&type=template&id=bdbcb5e2&"
import script from "./ThumbsUpIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ThumbsUpIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports